import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardPageComponent } from './pages/dashboard-page/dashboard-page.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { LoginComponent } from './pages/account-management-page/login/login.component';
import { ForgotPasswordComponent } from './pages/account-management-page/forgot-password/forgot-password.component';
import { VerificationCodeComponent } from './pages/account-management-page/forgot-password/verification-code/verification-code.component';
import { EmailVerificationComponent } from './pages/account-management-page/email-verification/email-verification.component';
import { ServicePageComponent } from './pages/service-page/service-page.component';
import { ShiftPageComponent } from './pages/shift-page/shift-page.component';
import { TermPageComponent } from './pages/term-page/term-page.component';
import { MembershipsPageComponent } from './pages/memberships-page/memberships-page.component';
import { UsersPageComponent } from "./pages/users-page/users-page.component";
import { ConfigurationPageComponent } from './pages/configuration-page/configuration-page.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'forgot-password', component: ForgotPasswordComponent,
    children: [
      { path: 'forgot-password', component: ForgotPasswordComponent },
    ]
  },
  { path: 'verification-code/:id/:email/:code', component: VerificationCodeComponent },
  { path: 'verification-code/:id/:email', component: VerificationCodeComponent },
  { path: 'email-verification', component: EmailVerificationComponent },
  {
    path: 'dashboard', component: DashboardPageComponent,
    children: [
      { path: 'home', component: HomePageComponent },
      { path: 'term', component: TermPageComponent },
      { path: 'service', component: ServicePageComponent },
      { path: 'shift', component: ShiftPageComponent },
      { path: 'users', component: UsersPageComponent },
      { path: 'memberships', component: MembershipsPageComponent },
      { path: 'configuration', component: ConfigurationPageComponent }
    ]
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/login',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
